import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, Star } from "lucide-react";
import { Logo } from "@/components/Logo";
import { NAV } from "@/components/Header";
import { SocialLinks } from "@/components/SocialFeeds";
import { useSite } from "@/context/SiteContext";
import { WEEKDAYS } from "@/lib/catalog";

const ampm = (t) => { const [h, m] = t.split(":").map(Number); return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`; };

export const HoursList = ({ className = "" }) => {
  const { site } = useSite() || {};
  if (!site) return null;
  return (
    <ul className={`space-y-1.5 text-sm ${className}`} data-testid="hours-list">
      {WEEKDAYS.map((d, i) => {
        const h = site.hours[String(i)];
        return (
          <li key={d} className="flex justify-between gap-6">
            <span className="text-mute">{d}</span>
            <span className={h.enabled ? "font-semibold text-ink" : "text-mute2"}>{h.enabled ? `${ampm(h.open)} – ${ampm(h.close)}` : "Cerrado"}</span>
          </li>
        );
      })}
    </ul>
  );
};

export const Footer = () => {
  const { site } = useSite() || {};
  return (
    <footer className="relative border-t border-line bg-surface">
      <div className="stripe-divider" />
      <div className="container-x grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-4">
        <div className="space-y-5">
          <Logo />
          <p className="text-sm text-mute">Especialistas en suspensión delantera, trasera y dirección en Mérida, Yucatán.</p>
          <SocialLinks />
        </div>
        <div>
          <h2 className="eyebrow mb-4">Navegación</h2>
          <ul className="space-y-2">
            {NAV.map((n) => <li key={n.to}><Link to={n.to} className="text-sm text-ink2 hover:text-green">{n.label}</Link></li>)}
          </ul>
        </div>
        <div className="space-y-3 text-sm">
          <h2 className="eyebrow mb-4">Visítanos</h2>
          <p className="flex gap-2 text-ink2"><MapPin size={16} className="mt-0.5 shrink-0 text-brand" />{site?.business.address}</p>
          <a href="tel:+529991919300" className="flex gap-2 text-ink2 hover:text-green"><Phone size={16} className="text-brand" />{site?.business.phone}</a>
          <a href={site?.business.google_review_url} target="_blank" rel="noopener noreferrer" className="flex gap-2 font-semibold text-green hover:underline" data-testid="footer-google-review-link">
            <Star size={16} /> Califícanos en Google
          </a>
        </div>
        <div>
          <h2 className="eyebrow mb-4 flex items-center gap-2"><Clock size={14} /> Horario</h2>
          <HoursList />
        </div>
      </div>
      <div className="border-t border-line pt-6 pb-24 sm:pb-6">
        <div className="container-x flex flex-col sm:flex-row justify-between gap-3 text-xs text-mute2">
          <span>© {new Date().getFullYear()} Taller de Suspensiones La Gringa · Mérida, Yucatán</span>
          <Link to="/admin" className="hover:text-green" data-testid="footer-admin-link">Acceso administrador</Link>
        </div>
      </div>
    </footer>
  );
};
